import { mapRasseTkv } from '@ps20-frontend/migrations';
import { IAnimalValueLabelElement, ValueLabelElement } from '@ps20-frontend/frontend-models';
import { Versicherungsnehmer } from '../reducers/versicherungsnehmer.reducer';
import { StatePreV2, StateV2 } from './2_migrate_rasse_pyrenaeen.interface';

const remapBreedCode = (breed: ValueLabelElement): IAnimalValueLabelElement => {
  if (!breed) {
    return breed;
  }
  const animalBreed = breed as IAnimalValueLabelElement;
  return {
    ...animalBreed,
    value: mapRasseTkv(animalBreed.value),
    motherBreed: animalBreed.motherBreed
      ? { ...animalBreed.motherBreed, value: mapRasseTkv(animalBreed.motherBreed.value) }
      : animalBreed.motherBreed,
  };
};

export const migrateRassePyrenaeen = (previousState: StatePreV2, newVersion: number): StateV2 => {
  return {
    ...previousState,
    version: newVersion,
    versicherungsnehmer: {
      ...previousState.versicherungsnehmer,
      breed: remapBreedCode(previousState.versicherungsnehmer?.breed),
      dogMotherBreed: remapBreedCode(previousState.versicherungsnehmer?.dogMotherBreed),
    } as Versicherungsnehmer,
  };
};
